import React from "react";
import { Link } from "react-router-dom";
import { routeCodes } from "../../config/routes";
import { getString } from "../../utilities";
import { printableCategoryNavNames } from "../../config/categories";

export default function PrintablesNav() {
  return (
    <div className="printablesnav">
      <div className="printablesnav-container">
        <Link
          to={`${routeCodes.CATEGORYPRINTABLES}${printableCategoryNavNames[0]}`}
          className={`printablesnav-link ${printableCategoryNavNames[0]}`}
          data-testid="printable-nav-link"
        >
          {getString("printables.categories.0")}
        </Link>
        <Link
          to={`${routeCodes.CATEGORYPRINTABLES}${printableCategoryNavNames[1]}`}
          className={`printablesnav-link ${printableCategoryNavNames[1]}`}
          data-testid="printable-nav-link"
        >
          {getString("printables.categories.1")}
        </Link>
        <Link
          to={`${routeCodes.CATEGORYPRINTABLES}${printableCategoryNavNames[2]}`}
          className={`printablesnav-link ${printableCategoryNavNames[2]}`}
          data-testid="printable-nav-link"
        >
          {getString("printables.categories.2")}
        </Link>
        <Link
          to={`${routeCodes.CATEGORYPRINTABLES}${printableCategoryNavNames[3]}`}
          className={`printablesnav-link ${printableCategoryNavNames[3]}`}
          data-testid="printable-nav-link"
        >
          {getString("printables.categories.3")}
        </Link>
      </div>
    </div>
  );
}
